var map = {
	"../pages/conseils/conseils.module": [
		161
	],
	"../pages/ecrire/ecrire.module": [
		163
	],
	"../pages/enregistrer/enregistrer.module": [
		165
	],
	"../pages/home/home.module": [
		169
	],
	"../pages/info/info.module": [
		177
	],
	"../pages/journal/journal.module": [
		178
	],
	"../pages/lang/lang.module": [
		179
	],
	"../pages/mal/mal.module": [
		180
	],
	"../pages/medicaments/medicaments.module": [
		181
	],
	"../pages/statistiques/statistiques.module": [
		182
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 160;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 160
// module chunks = 0